export const opacity = { "elevation": { "lg": 0.08, "md": 0.08, "sm": 0.08 }, "overlay": 0.5, "disabledGraphic": 0.5, "skeleton": { "lightMode": 0.08, "darkMode": 0.32 } };
